import HeaderAttachedBreakoutModule from './HeaderAttachedBreakoutModule'

export default HeaderAttachedBreakoutModule
